import { render } from "./DoctoresInfo.vue?vue&type=template&id=54d080d8&scoped=true"
import script from "./DoctoresInfo.vue?vue&type=script&lang=js"
export * from "./DoctoresInfo.vue?vue&type=script&lang=js"

import "./DoctoresInfo.vue?vue&type=style&index=0&id=54d080d8&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d080d8"]])

export default __exports__